import { useCallback } from 'react';
import { useStore } from './store';
import { ToastItem, ToastPosition } from './types';

export const useToastItem = () => {
  const { toasts } = useStore();

  const calculateOffset = useCallback(
    (
      toast: ToastItem,
      opts?: {
        gutter?: number;
        defaultPosition?: ToastPosition;
      },
    ) => {
      const { gutter = 8, defaultPosition } = opts || {};

      const relevantAlerts = toasts.filter(
        (t) =>
          (t.position || defaultPosition) ===
          (toast.position || defaultPosition),
      );
      const toastIndex = relevantAlerts.findIndex((t) => t.id === toast.id);
      const toastBefore = relevantAlerts.filter(
        (toast, i) => i < toastIndex && toast.visible,
      ).length;

      const offset = relevantAlerts
        .filter((t) => t.visible)
        .slice(...[toastBefore + 1])
        .reduce((acc, t) => acc + t.height + gutter, 0);

      return offset;
    },
    [toasts],
  );

  return {
    toasts,
    handlers: {
      calculateOffset,
    },
  };
};
